import { AiOutlineCalendar } from 'react-icons/ai'; // Example icon

const TenderDescriptionDate = ({ data }) => {
  return (
    <div className="gap-4 md:p-4 p-1 lg:text-xs text-[8px]">
      {/* Item 1 */}
      <div className="flex items-center">
        {/* <AiOutlineCalendar className="w-6 h-6 text-gray-500 mr-2" /> */}
        <label className="font-semibold text-gray-700 mr-2">Publish On:</label>
        <span className="text-gray-600">
          {new Date(data.publishOn).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
          })}{' '}
          ({data.publish_on_before} days ago)
          {/* ({data.publishdaysAgo} days back) */}
        </span>
      </div>

      {/* Item 2 */}
      <div className="flex items-center">
        {/* <AiOutlineCalendar className="w-6 h-6 text-gray-500 mr-2" /> */}
        <label className="font-semibold text-gray-700 mr-2">
          Submission Date:
        </label>
        <span className="text-gray-600">
          {new Date(data.submission_date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
          })}{' '}
          {/* ({data.expired_after} days more) */}
          {data.tender_status === 'live' && `(${data.expired_after} days more)`}
        </span>

        {/* <span className="text-gray-600">
          {data.submission_date} {' '}({data.expired_after} days more)
        </span> */}
      </div>

      {/* Item 3 */}
      <div className="flex items-center md:mt-2 mt-1">
        {/* <AiOutlineCalendar className="w-6 h-6 text-gray-500 mr-2" /> */}
        <label className="font-semibold text-gray-700 mr-2">Status:</label>
        {/* <span className="text-gray-600">{data.tender_status}</span> */}
        <span
          className={`relative capitalize ${
            data.tender_status === 'live' ? 'text-green-500' : 'text-red-500'
          }`}
        >
          {data.tender_status}
        </span>
      </div>
    </div>
  );
};

export default TenderDescriptionDate;
